import { render } from "./AddPlatFormVideo.vue?vue&type=template&id=6dd628b3&scoped=true"
import script from "./AddPlatFormVideo.vue?vue&type=script&lang=js"
export * from "./AddPlatFormVideo.vue?vue&type=script&lang=js"

import "./AddPlatFormVideo.vue?vue&type=style&index=0&id=6dd628b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd628b3"]])

export default __exports__